export default (address, formattedAddress, siteName) => ({
  shipping_method: 'store pick-up',
  shipping_type: 'normal',
  first_name: formattedAddress.given_name,
  last_name: formattedAddress.family_name,
  street_address: address.line_1 !== '' ? `${address.line_1}, ${address.streetName}` : address.streetName,
  street_number: siteName,
  postal_code: address.postcode,
  city: address.city,
  country: address.countryCode,
});
